import React from 'react'
import { Layer, Line } from 'react-konva'

import { Line as LineInterface } from '../../../reducers/editPhoto'
import { SquareLine, TriangleLine } from '../shapes'

interface DrawingLayerProps {
    lines: LineInterface[]
}

/**
 * 通常の消しゴム描画レイヤー
 * 黒色のマスク線を描画
 */
export const DrawingLayer: React.FC<DrawingLayerProps> = ({ lines }) => {
    return (
        <Layer>
            {lines.map((line: LineInterface, i: number) => {
                if (line.head === 'circle')
                    return (
                        <Line
                            key={i}
                            points={line.points}
                            stroke="black"
                            strokeWidth={line.headSize}
                            tension={1}
                            opacity={1}
                            lineCap="round"
                        />
                    )
                if (line.head === 'square') return <SquareLine key={i} line={line} />
                if (line.head === 'triangle') return <TriangleLine key={i} line={line} />
                return null
            })}
        </Layer>
    )
}
